<template>
	<div>
		<!-- 合同信息 -->
		<!-- <h3 style="padding: 10px;">合同信息</h3> -->
		<section>
			<el-form :model="formInline" :inline="true" label-width="80px">
				<el-form-item label="合同名称">
					<el-input v-model="formInline.name" placeholder="输入合同名称" style="width: 120px;"></el-input>
				</el-form-item>
				<el-form-item label="合同类型">
					<el-select style="width: 120px;" v-model="formInline.type" placeholder="请选择合同类型">
						<el-option label="托管协议" value="托管协议"></el-option>
						<el-option label="租赁合同" value="租赁合同"></el-option>
						<el-option label="服务合同" value="服务合同"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="合同状态">
					<el-select style="width: 120px;" v-model="formInline.status" placeholder="请选择合同状态">
						<el-option label="已过期" value="已过期"></el-option>
						<el-option label="未开始" value="未开始"></el-option>
						<el-option label="执行中" value="执行中"></el-option>
						<el-option label="即将过期" value="即将过期"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="签约单位">
					<!-- <el-autocomplete v-model="formData.company" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" value-key="unitName"
					      clearable @clear="clearSearch" ref="myAutocomplete"></el-autocomplete> -->
					<!-- {{formData}} -->
					<el-autocomplete v-model="formInline.contractor" :fetch-suggestions="querySearchAsync"
						placeholder="请输入签约单位" value-key="unitName" clearable @clear="clearSearch" ref="myAutocomplete">
					</el-autocomplete>
					<!-- <el-select v-model="formData.contractor" placeholder="请选择签约单位">
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select> -->
				</el-form-item>
				<el-form-item label="签约日期">
					<el-date-picker v-model="formInline.signingDate" type="date" placeholder="选择日期"
						style="width: 140px;" value-format="timestamp">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="时间排序">
					<el-select style="width: 140px;" v-model="formInline.sort" placeholder="请选择合同类型">
						<el-option label="开始时间升序" value="1"></el-option>
						<el-option label="开始时间降序" value="2"></el-option>
						<el-option label="结束时间升序" value="3"></el-option>
						<el-option label="结束时间降序" value="4"></el-option>
						<el-option label="签约时间升序" value="5"></el-option>
						<el-option label="签约时间降序" value="6"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button @click="getAll" type="primary">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button @click="handleClear">清空</el-button>
					<el-popover placement="bottom" width="150" v-model="show" class="left10 right10">
						<el-checkbox-group v-model="checkList" @change="checkChange">
							<el-checkbox :label="val" v-for="(val,key) in oldTitleObj" :key="key"
								:disabled="val==oneRow"></el-checkbox>
						</el-checkbox-group>
						<el-button slot="reference">筛选列表</el-button>
					</el-popover>
				</el-form-item>

				<div style="float: right;margin-right: 20px;">
					
					<div v-hasPermi="['apartment:contract:import']" style="display: inline-block;margin-right: 10px;">
						<el-upload action="/api/admin/bdContract/importContract" name="multipartFile"
							:show-file-list="false" :headers="headers" :on-success="success">
							<el-button type="primary">导入合同</el-button>
						</el-upload>
					</div>
					<el-button v-hasPermi="['apartment:contract:import']" type="primary" @click="addTemplate">下载导入模板</el-button>
					<!--el-button type="danger" @click="deleteSelected">删除</el-button-->
					<el-button v-hasPermi="['apartment:contract:add']" type="primary" @click="addClick" v-if="isXz!=3">新增合同</el-button>
					<el-button v-hasPermi="['apartment:contract:export']" @click="exportData" type="warning">导出</el-button>
				</div>
			</el-form>
			<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
				@selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column v-if="key!='status'" v-for="(val,key) in titleObj" :prop="key" :label="val"
					align="center">
				</el-table-column>
				<el-table-column v-if="key=='status'" style="color: red;" v-for="(val,key) in titleObj" :prop="key"
					:label="val" align="center">
					<template slot-scope="{row}">
						<img style="width: 20px;" v-if="row.status=='即将过期'" src="../../assets/imgs/jg.png" alt="">
						<div :style="{'color':(row.status=='即将过期'?'red':'')}">{{row.status}}</div>
					</template>
				</el-table-column>
				<el-table-column  prop="tel" label="操作" align="center" width="250">
					<template slot-scope="scope">
						<el-button size="mini" @click="handleCheck(scope.row)">详情</el-button>
						<el-button v-hasPermi="['apartment:contract:edit']" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button v-hasPermi="['apartment:contract:remove']" size="mini" @click="handleDelete(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background :page-size="pageSize" layout="total, prev, pager, next,sizes"
				@current-change="handleCurrentChange" :total="totalNum" @size-change="handleSizeChange" />
		</section>

		<!-- 新增、修改模态框 -->
		<addConstractInfor :title="title" :obj="obj" @addSubmit="addSubmit" :dialogVisible="dialogVisible">
		</addConstractInfor>
	</div>
</template>

<script>
	import addConstractInfor from './component/addConstractInfor.vue';
	import tableParValueChange from './component/Cje.js';
	export default {
		data() {
			return {
				headers: { //请求头
					Authorization: localStorage.access_token,
				},
				oneRow: "", //当checkList列表只有一项时,选择框不可点击
				checkList: ["合同编号", "合同名称", "合同类型", "开始时间", "结束时间", "合同金额", "签约日期", "合同状态", "创建人", "签约单位"],
				show: false, //控制筛选列的多选框
				titleObj: { //表头
					number: "合同编号",
					name: "合同名称",
					type: "合同类型",
					startTime: "开始时间",
					endTime: "结束时间",
					money: "合同金额",
					contractor: "签约单位",
					signingDate: "签约日期",
					status: "合同状态",
					createUserName: "创建人"
				},
				oldTitleObj: {}, //备份表头
				multipleSelection: [],
				formInline: {
					name: null,
					type: null,
					signingDate: null,
					currentPage: 1,
					pageSize: 10,
					contractor: null,
					status: null,
					sort: "1" //时间排序
				},
				oldFormInline: "",
				obj: {},
				tableData: [],
				pageSize: 10, //
				currentPage: 1, //当前页号
				totalNum: 0, //总页数
				title: "",
				dialogVisible: false,
				flag: null,
				formData: {
					name: null,
					type: null,
					signingDate: null,
				},
				adjustVisible: false, //调剂模态框的显隐
				adjustForm: {
					region: null,
				},
				isXz: null
			}
		},
		components: {
			addConstractInfor,
		},
		watch: {
			"$route"(val) {

				console.log(val);
				// this.getPath()
			}
		},
		mounted() {

			console.log(this.$route)
			this.isXz = localStorage.getItem('roleId')
			this.formInline.contractor = this.$route.query.name
			this.oldFormInline = JSON.parse(JSON.stringify(this.formInline))
			this.oldTitleObj = JSON.parse(JSON.stringify(this.titleObj))
			this.getAll()
		},
		methods: {
			clearSearch() {
				this.$refs.myAutocomplete.handleFocus()
			},
			querySearchAsync(queryString, cb) {
				if (this.formData.contractor == undefined) {
					this.formData.contractor = ''
				}
				this.$http.get('/api/ownerManage/getOwners?company=' + this.formData.contractor).then(res => {
					console.log("查询所有单位信息", res.data.data);
					let result = res.data.data;
					cb(result);
				})
			},
			success(res) {
				if (res.code == 0) {
					this.getAll()
					this.$message.success("导入成功")
				} else {
					this.$message.error("导入失败")
				}
			},
			addTemplate() { //下载导入模板
				this.$http.post(`/api/export/exportContractModel`, {}, {
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json;charset=utf-8",
					},
					responseType: "blob"
				}).then(res => {
					const link = document.createElement("a");
					let blob = new Blob([res.data], {
						type: "application/vnd.ms-excel"
					});
					link.style.display = "none";
					link.href = URL.createObjectURL(blob);
					link.download = "合同导入模板.xls";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
			},
			checkChange(val) { //筛选列复选框被改变
				var newObj = {}
				for (var key in this.oldTitleObj) {
					if (val.indexOf(this.oldTitleObj[key]) != -1) {
						newObj[key] = this.oldTitleObj[key]
					}
				}
				this.titleObj = newObj;
				if (val.length == 1) { //只有一列时,复选框禁止勾选
					this.oneRow = val[0];
					this.$message.warning("表格内容至少显示一列")
					return;
				}
				this.oneRow = ""
			},
			addSubmit(list) {
				console.log(list)
				let url = "/api/bdContract/addContract"
				if (this.title == '编辑合同') {
					url = "/api/bdContract/editContract"
				}
				if (list.startTime != null && list.endTime != null) {
					console.log(list.startTime)
					list.startTime = new Date(list.startTime).getTime()
					list.endTime = new Date(list.endTime).getTime()

				}
				if (list.startTime > list.endTime) {
					this.$message.error("结束时间不能小于开始时间")
					return
				}
				// return
				this.$http.post(url, list).then(res => {
					if (res.data.code == 0) {
						this.addClose()
						this.$message.success(res.data.message)
						this.getAll();
					} else {
						this.$message.error(res.data.message)
					}

				}).catch(err => {
					console.log(err)
				})
			},
			getAll() {
				this.$http.post("/api/bdContract/findContract", {
					...this.formInline
				}).then(res => {
					this.tableData = res.data.data.items
					this.totalNum = res.data.data.totalNum

					res.data.data.items.forEach(val => {
						if (val.money.split("").indexOf('￥') == -1) {
							val.money = tableParValueChange(val.money, '￥', 2)
						}

						val.startTime = val.startTime.split("T")[0]
						val.endTime = val.endTime.split("T")[0]
						val.signingDate = val.signingDate.split("T")[0]
					})

					console.log(res)
				}).catch(err => {
					console.log(err)
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			//清空
			handleClear() {

				this.formInline = JSON.parse(JSON.stringify(this.oldFormInline))
				this.formInline.contractor = null
				this.getAll()
			},
			//查询
			handleQuery() {

			},
			//子组件关闭父组件弹窗
			addClose() {
				this.title = ''
				this.dialogVisible = false
			},
			// 新增
			addClick() {
				this.title = "新增合同";
				this.dialogVisible = true;
				this.flag = true;

			},
			// 删除所选择的
			deleteSelected() {

			},
			// 导出
			exportData() {
				this.$http.post(`/api/export/dynamicExportContract`, {
					...this.formInline,
					heads: this.checkList
				}, {
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json;charset=utf-8",
					},
					responseType: "blob"
				}).then(res => {
					const link = document.createElement("a");
					let blob = new Blob([res.data], {
						type: "application/vnd.ms-excel"
					});
					link.style.display = "none";
					link.href = URL.createObjectURL(blob);
					link.download = "合同数据.xls";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
			},
			handleCheck(row) {
                this.title = "查看合同";
				this.dialogVisible = true;
				this.flag = false;
				this.obj = {
					...row
				};
			}, // 编辑
			handleEdit(row) {
				this.title = "编辑合同";
				this.dialogVisible = true;
				this.flag = false;
				this.obj = {
					...row
				};
			},
			// 调剂
			handleDelete(row) {
				// if (this.multipleSelection.length == 0) {
				// 	this.$message.warning("请勾选要删除的列表")
				// 	return
				// }

				let userId = []
				// this.multipleSelection.forEach(item => {
				// 	userId.push(item.id)
				// })
				userId.push(row.id);

				this.$confirm('确定删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					this.$http.post("/api/bdContract/deleteContract", {
						ids: userId
					}).then(res => {
						if (res.data.code == 0) {
							this.$message.success(res.data.message)
							this.getAll();
						} else {
							this.$message.error(res.data.message)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'warning',
						message: '已取消删除'
					});
				});
			},
			// 分页
			// 当前页
			handleCurrentChange(val) {
				console.log(val);
				this.formInline.currentPage = val;
				this.getAll();
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.getAll();
			},
		}
	}
</script>

<style scoped="scoped">
	section {
		margin-top: 20px;
	}
</style>
